import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M2 9a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m4 0a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m0-4a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m4 4a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m0-4a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m0-4a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0"
    />
  </svg>
);
const SvgDrag = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="drag" {...props} />;
export default SvgDrag;
